<template>
    <modal v-bind="modalAttrs" ref="modal" @okClicked="okClicked" @cancelClicked="cancelClicked">
        <template v-slot:default="">
            <div v-if="!loading">
                <slot name="default"></slot>
            </div>
            <div v-else>
                <slot name="loading"></slot>
            </div>
        </template>
    </modal>
</template>

<script>
import ModalProps from '../containers/ModalProps';
import axios from 'secure-axios';

export default {
    name  : 'confirm-post-modal',
    props : {
        ...ModalProps,
        ajaxMethod : { type : String, default : 'form' },

        url    : { type : String, default : '' },
        params : { type : Object, default : null }
    },
    data () {
        return {
            hasFooter : true,
            loading   : false
        };
    },
    computed : {
        modalAttrs () {
            return {
                width          : this.width,
                title          : this.title,
                enterAnimation : this.enterAnimation,
                exitAnimation  : this.exitAnimation,

                dialog            : true,
                isCustomDialog    : true,
                okButton          : this.okButton,
                cancelButton      : this.cancelButton,
                noCloseOnBackdrop : this.noCloseOnBackdrop,
                noCloseOnEsc      : this.noCloseOnEsc,

                okButtonColor     : this.okButtonColor,
                cancelButtonColor : this.cancelButtonColor,

                okButtonDesign     : this.okButtonDesign,
                cancelButtonDesign : this.cancelButtonDesign,

                color       : this.color,
                headerColor : this.headerColor,
                footerColor : this.footerColor,
                bodyColor   : this.bodyColor
            };
        }
    },
    methods : {
        async okClicked () {
            this.$emit('okClicked');
            this.loading = true;
            this.$refs.modal.hideFooter();
            let response;
            try {
                response = await axios.perform(this.url, this.params, this.ajaxMethod);
            } catch (e) {
                response = e.response;
            }
            this.$emit('response', response.data);
            this.loading = false;
        },

        cancelClicked () {
            this.close();
        },

        show () {
            const modal = this.$refs.modal;
            modal.showFooter();
            modal.show();
        },

        close () {
            const modal = this.$refs.modal;
            modal.close();
            modal.showFooter();
        }
    }
};
</script>
